import { type VariantProps, cva } from 'class-variance-authority';

export const toggleButtonStyles = cva(
  [
    'relative',
    'inline-flex',
    'flex-shrink-0',
    'rounded-full',
    'border-2',
    'border-transparent',
    'transition-colors',
    'duration-200',
    'ease-in-out',
  ],
  {
    variants: {
      intent: {
        default: ['h-5', 'w-10'],
        old: ['h-5', 'w-10'],
      },
      checked: {
        true: [],
        false: [],
      },
      disabled: {
        true: ['opacity-50', 'cursor-not-allowed'],
        false: ['cursor-pointer'],
      },
    },
    compoundVariants: [
      { intent: 'default', disabled: true, className: 'bg-neutral-400' },
      { intent: 'default', checked: true, disabled: false, className: 'bg-blue-200' },
      { intent: 'default', checked: false, disabled: false, className: 'bg-blue-100' },
      { intent: 'old', checked: true, disabled: false, className: 'bg-blue-300' },
      { intent: 'old', checked: false, disabled: false, className: 'bg-[#ccc]' },
      { intent: 'old', disabled: true, className: 'bg-[#ccc]' },
    ],
    defaultVariants: {
      intent: 'default',
      checked: false,
      disabled: false,
    },
  }
);

export const toggleSpanStyles = cva(
  [
    'pointer-events-none',
    'inline-block',
    'transform',
    'rounded-full',
    'bg-white',
    'shadow',
    'ring-0',
    'transition',
    'duration-200',
    'ease-in-out',
  ],
  {
    variants: {
      intent: {
        default: ['h-4', 'w-4'],
        old: ['h-4', 'w-4'],
      },
      checked: {
        true: [],
        false: 'translate-x-0',
      },
    },
    compoundVariants: [
      { intent: 'default', checked: true, className: 'translate-x-5' },
      { intent: 'old', checked: true, className: 'translate-x-4.5' },
    ],
    defaultVariants: {
      intent: 'default',
      checked: false,
    },
  }
);

export const toggleLabelStyles = cva([], {
  variants: {
    intent: {
      default: ['ml-3', 'font-inter', 'text-[16px]', 'font-normal', 'leading-[27px]', 'text-black'],
      old: ['ml-3', 'font-canela', 'text-[16px]', 'font-semibold', 'text-black'],
    },
    disabled: {
      true: ['opacity-50', 'cursor-not-allowed'],
      false: ['cursor-pointer'],
    },
  },
  defaultVariants: {
    intent: 'default',
    disabled: false,
  },
});

export type ToggleButtonVariantsProps = VariantProps<typeof toggleButtonStyles>;
